// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".customLineH {\n  line-height: 22px;\n}\n.fix-scrollbar::-webkit-scrollbar {\n  width: 4px;\n  height: 4px;\n}\n.fix-scrollbar::-webkit-scrollbar-thumb {\n  border-radius: 4px;\n  background-color: rgba(84, 84, 84, 0.5);\n}\n.borderTabs {\n  border-bottom: 0.5px solid #e6e6e6;\n  width: -webkit-fit-content;\n  width: -moz-fit-content;\n  width: fit-content;\n}", ""]);
// Exports
module.exports = exports;
